import { useConfig } from '@/composables';

const remoteHazardAssetsUrl = useConfig().value.remoteHazardAssets.iconAssetsPathSvg;

export const CLOSURE_HAZARD_ICONS = {
  'ew-facility-or-park-closure': `${remoteHazardAssetsUrl}/ew-facility-or-park-closure.svg?url`,
  'ew-road-closure': `${remoteHazardAssetsUrl}/ew-road-closure.svg?url`,
  'ew-school-closure': `${remoteHazardAssetsUrl}/ew-school-closure.svg?url`,
};
